import React, { useState } from 'react'
import { StyledContact } from './Contact.style'
// import "../assets/style/contact.css"

import Phone from "../assets/icons/Phone"
import Email from "../assets/icons/Email"
import Location from "../../../assets/icons/Location"
import Facebook from "../../../assets/icons/Facebook"
import Telegram from "../../../assets/icons/Telegram"
import Instagram from "../../../assets/icons/Instagram"

import Dispatcher from "../assets/images/dispatcher.jpg"
import VideoImg from "../../../assets/images/contact.mp4"
import DispatcherVideo from "../../../assets/images/about.mp4"



export default function Contact() {

  const [user, setUser] = useState({
    "name": "",
    "phone": "",
    "email": "",
    "message": ""
  })
  const [open, setOpen] = useState(false)
  setTimeout(function () {
    setOpen(true)
  }, 4000);

  const changeUser = (e) => {
    const { name, value } = e.target
    setUser((p) => ({
      ...p,
      [name]: value
    }))
  }

  const sendMessage = (e) => {
    e.preventDefault();
    console.log(user)
    setUser({
      "name": "",
      "phone": "",
      "email": "",
      "message": ""
    })
  }


  return (
    <StyledContact open={open}>
      <header className='contact-header'>
        <video className='contact-video' src={VideoImg} autoPlay loop muted ></video>
        <div className='shadow'></div>
        <div className='container'>
          <div className='contact-main'>
            <h1>Contact</h1>
            <p>Transport anything from anywhere</p>
          </div>
        </div>
      </header>

      <section className='section-contact'>
        <div className='container'>
          <div className='contact'>
            <div className='contact-left'>
              <div className='contact-item'>
                <Phone />
                <div>
                  <h3>Call Us</h3>
                  <a href='tel: 1(202)9380805'>1(202)9380805</a>
                </div>
              </div>
              <div className='contact-item'>
                <Email />
                <div>
                  <h3>Email Us</h3>
                  <a href="https://mail.google.com/mail/u/0/#search/safeeldinc%40gmail.com" target="blank">
                    support@sfeldinc.com
                  </a>
                </div>
              </div>
              <div className='contact-item'>
                <Location />
                <div>
                  <h3>Visit Office</h3>
                  <a href='https://www.google.com/maps/place/2263+84th+St+%235th,+Brooklyn,+NY+11214,+%D0%A1%D0%A8%D0%90/@40.6020607,-73.9906073,16.83z/data=!4m5!3m4!1s0x89c24506974256f3:0x3c4a028a8d292e16!8m2!3d40.6021678!4d-73.9906736'>Location:2263 84th Steet Ste
                    5th Brooklyn, NY 11214 USA</a>
                </div>
              </div>

              <div className='social'>
                <a href="https://www.facebook.com/profile.php?id=100086904313574"> <Facebook /></a>
                <a href={"https://t.me/sfeld_24"}><Telegram /></a>
                <a href='https://www.instagram.com/sf_eld'><Instagram /></a>
              </div>
            </div>
            <div className='contact-right'>
              <img className='dispatcher' src={Dispatcher} alt="contact" />
              <video className='main-video' src={DispatcherVideo} autoPlay loop muted ></video>
            </div>
          </div>
          <h2>CONTACT US</h2>
        </div>
      </section>

      <section className='section-send'>
        <div className='container'>
          <div className='send'>
            <h1 className='redline'><span></span>Send us a message</h1>

            <form className='form' autoComplete='off' onSubmit={sendMessage}>
              <input
                placeholder='Full name'
                name='name'
                onChange={changeUser}
                value={user.name}
                required={true}
              />
              <input
                placeholder='Phone number'
                name='phone'
                onChange={changeUser}
                value={user.phone}
                required={true}
              />
              <input
                placeholder='Email addres'
                name='email'
                type={"email"}
                onChange={changeUser}
                value={user.email}
                required={true}
              />
              <textarea
                placeholder='Type your message here...'
                name='message'
                onChange={changeUser}
                value={user.message}
              />

              <button type='submit'>Send message</button>
            </form>
          </div>
        </div>
      </section>

      <section className='section-google'>

        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.256331828373!2d-73.9906736!3d40.6021678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24506974256f3%3A0x3c4a028a8d292e16!2zMjI2MyA4NHRoIFN0ICM1dGgsIEJyb29rbHluLCBOWSAxMTIxNCwg0KHQqNCQ!5e0!3m2!1sru!2s!4v1667632364902!5m2!1sru!2s"
          style={{ border: "0" }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </section>
    </StyledContact>
  )
}
